 angular.module('app')
  .controller('ArtifactCollectionController', function ($scope,$q,$document,AppService, $timeout,$filter) {
 	
    var trace = angular.trace;

  	$scope.scrollIndex = 0;

    $scope.pendingArtifact = [];
    $scope.cache = null;
    $scope.collectedArtifacts = 0;
    $scope.pulsing = true;
    $scope.draggingElement = false; // needed to prevent triggering clicks on dragging artifact;
    //$scope.$watch("currentAdventure",onAdventureSelection);
    //$scope.$watch("currentArtifact",onArtifactSelection);
    //$scope.$watch("currentPageIndex",onPageSelection);

   // $timeout(function(){
        onAdventureSelection();
        onPageSelection();
        onArtifactSelection();
    //},2000);
    

    $scope.periodOptions = {
    	"ui-floating": false,
        revert: true,
        receive:function(){
            
        }

    };

    function sortDates(a,b){
        return parseInt(a.date) > parseInt(b.date) ? 1 : -1;
    }

    $scope.setDragging = function(value){
        $scope.pulsing = false;
        $scope.draggingElement = value;
    };


    $scope.artifactPositioned = function(){
        $scope.cache = null;
        $scope.currentLocation.complete = true;
        $scope.collectedArtifacts ++;
        $scope.locationComplete();
        $timeout(function(){
            $scope.$apply(function(){
                for(var i = 0, count = $scope.periods.length; i < count; i ++){
                    var period = $scope.periods[i];
                    period.artifacts.sort(sortDates);
                }
            });
            
        },0);
    };

    $scope.advance = function(){
    	if($scope.scrollIndex < 2) $scope.scrollIndex ++;
    };
    $scope.rewind = function(){
    	if($scope.scrollIndex > 0) $scope.scrollIndex --;
    };

    $scope.isCorrect = function(id){
        if(!$scope.cache) return;
        
        var period = id;
        var adventure = $scope.currentAdventure.id;
        var uid = adventure + ":" + period;
        var correct = $scope.cache.periods.indexOf(uid) !== -1;
        return correct ? "correct" : "incorrrect";
    };


    $scope.showArtifact = function(artifact,e){
        if($scope.draggingElement) return;

        $scope.setCurrentArtifact(artifact, $q.defer().promise.then(function(){
            $scope.setCurrentPage($scope.PAGE_ARTIFACT_COLLECTION);
            $scope.currentArtifact = null;
        }));

    };
    function onPageSelection(value){
        $scope.setScalingPrevention(true);
    }

    function onAdventureSelection(val){
        $scope.periods = $scope.currentAdventure.periods;
        for(var i = 0, count = $scope.periods.length; i < count; i ++){
            var period = $scope.periods[i];
            if(!period.artifacts) period.artifacts = [];
        }
    }

    function onArtifactSelection(){
        var val = $scope.lastArtifact;
        for(var i = 0, count = $scope.periods.length; i < count; i++){
            var period = $scope.periods[i];
            if(period.artifacts.indexOf(val) > -1) return;
        }
        if(!val.complete) $scope.pendingArtifact = [val];
        $scope.cache = val;
    }


  });
